import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import Page from "../../../components/Page/Page";
import CardScreen from "./Card/CardScreen";
import SitePagesScreen from "./SitePages/SitePagesScreen";
import { useContext } from "react";
import SharedStateContext from "../../../components/SharedStateProvider";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../features/userSlice";

export default function PageBuildingViewScreen() {
  const response = useSelector(selectUserData)?.data?.products?.assets;
  const accessToken = useSelector((state: any) => state.auth.accessToken);
  const [searchParams] = useSearchParams();
  const siteName = searchParams.get("selectedSite") || "";
  const navigate = useNavigate();
  const { pageRefreshStatus, setPageRefreshStatus } =
    useContext(SharedStateContext);
  const setSelectedSiteName = () => {
    navigate(`/performance/page_builder/`);
  };
  const hasViewPagesListPermission = CheckPermissions(
    response,
    "page_management",
    "view_pages_list"
  );

  return hasViewPagesListPermission ? (
    <Page>
      <CardScreen
        selectedSiteName={siteName}
        setSelectedSiteName={setSelectedSiteName}
      />
      <SitePagesScreen
        userToken={accessToken}
        selectedSiteName={siteName}
        pageRefreshStatus={pageRefreshStatus}
        setPageRefreshStatus={setPageRefreshStatus}
        response={response}
      />
      <Outlet />
    </Page>
  ) : (
    <Page404 />
  );
}
